var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6663 6.66667H13.333C14.0694 6.66667 14.6663 7.26362 14.6663 8C14.6663 8.73638 14.0694 9.33333 13.333 9.33333H10.6663L7.99967 14H5.99967L7.33301 9.33333H4.66634L3.33301 10.6667H1.33301L2.66634 8L1.33301 5.33333H3.33301L4.66634 6.66667H7.33301L5.99967 2H7.99967L10.6663 6.66667Z",
    stroke: "#6F6B7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/travel.6dfe58b1b886458c9a08c01c8d597b4c.svg";
export { ForwardRef as ReactComponent };